"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function HappensSection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="relative w-full py-16 px-4 bg-background">
      <div className="container mx-auto max-w-4xl">
        <div ref={ref} className={`transition-all duration-700 ease-out-back ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Card className="max-w-2xl mx-auto bg-surface border-none overflow-hidden shadow-strong">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1463994/img/image_unric5jy.jpg" alt="Hoosier Open 9-Ball Tour" className="w-full h-auto object-cover" />
            <CardContent className="flex flex-col items-center gap-6 py-8">
              <h2 className="text-2xl md:text-3xl font-display font-bold text-center text-foreground">
                Indiana's Premier Competitive Pool Tour
              </h2>
              <Link to="https://www.hoosieropen9-balltour.com" newTab className="btn-primary">
                Visit Official Website
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}